module.exports = __webpack_public_path__ + "img/c01_unittrireme_Normal_ua.7da5b9c6.webp";